module.exports = "https://pearup-project-assets.s3.eu-central-1.amazonaws.com/scratch/assets/c9528ee4be1a12380a6c9caf73bd99e9.svg";